import axios from "axios";

const isDev = process.env.NODE_ENV === "development";

const ROUTES = [
  { prefix: "/api/auth", target: process.env.REACT_APP_AUTH_PROXY_TARGET || `http://${window.location.hostname}:8000` },
  { prefix: "/api/brd", target: process.env.REACT_APP_BRD_PROXY_TARGET || `http://${window.location.hostname}:8001` },
  { prefix: "/api/proposal", target: process.env.REACT_APP_PROPOSAL_PROXY_TARGET || `http://${window.location.hostname}:8002` },
  { prefix: "/api/automation", target: process.env.REACT_APP_AUTOMATION_PROXY_TARGET || `http://${window.location.hostname}:8003` },
  { prefix: "/api/migration", target: process.env.REACT_APP_MIGRATION_PROXY_TARGET || `http://${window.location.hostname}:8004` },
  { prefix: "/api/admin", target: process.env.REACT_APP_AUTH_PROXY_TARGET || `http://${window.location.hostname}:8000` },
  { prefix: "/api/test-case", target: process.env.REACT_APP_TEST_CASE_PROXY_TARGET || `http://${window.location.hostname}:8007` },
  { prefix: "/api/csm", target: process.env.REACT_APP_CSM_PROXY_TARGET || `http://${window.location.hostname}:8005` },
  { prefix: "/api/sdd", target: process.env.REACT_APP_SDD_PROXY_TARGET || `http://${window.location.hostname}:8009` },
  { prefix: "/api/training", target: process.env.REACT_APP_TRAINING_EVAL_PROXY_TARGET || `http://${window.location.hostname}:8013` },
  { prefix: "/api/ba", target: process.env.REACT_APP_MOM_PROXY_TARGET || `http://${window.location.hostname}:8011` },
  { prefix: "/api/support-copilot", target: process.env.REACT_APP_SUPPORT_COPILOT_PROXY_TARGET || `http://${window.location.hostname}:8014` },
  { prefix: "/api/log-analyze", target: process.env.REACT_APP_LOG_ANALYZE_PROXY_TARGET || `http://${window.location.hostname}:8012` },
];

function isAbsoluteUrl(url) {
  return /^https?:\/\//i.test(url);
}

function rewriteUrl(url) {
  if (!isDev || !url || isAbsoluteUrl(url)) return url;
  const match = ROUTES.find((r) => url.startsWith(r.prefix));
  return match ? `${match.target}${url}` : url;
}

export function installDevApiRouting() {
  if (window.__EDGE_DEV_API_ROUTING_INSTALLED__) return;
  window.__EDGE_DEV_API_ROUTING_INSTALLED__ = true;

  // Patch window.fetch globally to handle dev routing & production token limits check
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    let rewrittenInput = input;
    if (isDev && input) {
      if (typeof input === "string") {
        rewrittenInput = rewriteUrl(input);
      } else if (input instanceof Request) {
        const rewritten = rewriteUrl(input.url);
        if (rewritten !== input.url) {
          rewrittenInput = new Request(rewritten, input);
        }
      }
    }

    const response = await originalFetch(rewrittenInput, init);

    if (response.status === 403 || response.status === 400) {
      try {
        const clone = response.clone();
        const data = await clone.json();
        const detail = data?.detail;
        const message = typeof detail === "string" ? detail : detail?.message;
        if (message && message.toLowerCase().includes("token limit")) {
          window.dispatchEvent(new CustomEvent("quota-limit-exceeded", {
            detail: { message: "Token limit exceeded. Please contact your admin to increase the limit." },
          }));
        }
      } catch (e) {
        // silent fail
      }
    }
    return response;
  };

  // Patch axios requests globally (only in dev mode)
  if (isDev) {
    axios.interceptors.request.use((config) => {
      if (typeof config.url === "string") {
        config.url = rewriteUrl(config.url);
      }
      return config;
    });
  }
}
